<template src='./processedFiles.pug' lang='pug'></template>

<script>
import PageTitle from '../../../layout/pageTitle/PageTitle'
import FilterPortlet from '../../../layout/filterPortlet/FilterPortlet'
import FormSearch from '../../../form/formSearch/FormSearch'
import DateRange from '../../../input/dateRange/DateRange'
import TreeGrid from '../../../treeGrid/TreeGrid'
import { EXPORT_TREEGRID } from '../../../../../build/jsonToExcel/exportRoutes.js'
import language from '../../../../../build/language/index'
import { startTreeGridLoading, stopTreeGridLoading } from '../../../../utils/grid-load-transition.js'

export default {
  name: 'ProcessedFiles',

  components: {
    PageTitle,
    FilterPortlet,
    FormSearch,
    DateRange,
    TreeGrid
  },

  data () {
    return {
      gridId: '#processedFilesGrid',
      treeGridCfg: {},
      audit: {},
      dateRange: {},
      firstDate: new Date(),
      finalDate: new Date(),
      showTreegrid: false,
      exportUrl: EXPORT_TREEGRID,
      filter: {
        entityId: null
      },
      result: {},
      treeGridFileName: 'ExtratoBancario',
      disableSearchButton: false
    }
  },

  methods: {
    validate () {
      let self = this
      return new Promise(resolve => {
        this.$validator.validateAll().then((result) => {
          if (result && this.$refs.dateRange.validate()) {
            this.showTreegrid = true
            startTreeGridLoading(self.gridId)
            this.search().finally(() => {
              resolve()
            })
          } else {
            resolve()
          }
        })
      })
    },

    search () {
      this.disableSearchButton = true
      let inicio = this.dateRange.fromDate
      let fim = this.dateRange.toDate
      let filter = {
        inicio: inicio,
        fim: fim,
        lang: language.getCookieByName('language')
      }
      return new Promise((resolve, reject) => {
        this.$store.dispatch('searchFiles', filter)
          .then((response) => {
            window.DisposeGrids()
            this.result = response.data
            this.treeGridCfg = response.data.Cfg.Layout
            stopTreeGridLoading(this.gridId)
            this.disableSearchButton = false
            resolve()
          }).catch((error) => {
            this.$root.$refs.notification.error(error)
            stopTreeGridLoading(this.gridId)
            this.disableSearchButton = false
            reject()
          })
      })
    }
  }
}
</script>

<style lang='css' scoped>
.input-button>button {
  margin: 24px 0 0 0;
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
  height: 36px;
  float: left;
}

#logDeAuditoriaWrapper {
  width: 100%;
}

#divTreeGridAuditoria {
  min-width: 100%;
  min-height: 500px;
}

.check {
  text-align: center;
}

.filterButton {
  width: 3vw;
  margin: 0px !important;
}

.col-search{
  width: 53.5%;
}

.search-button {
  min-width: 7vw;
}
</style>



// WEBPACK FOOTER //
// ProcessedFiles.vue?6c2726a0